import React, { useEffect, useState } from "react";
import {
  People,
  PendingActions,
  SpeakerNotesRounded,
} from "@mui/icons-material";
import { CardsContainer } from "./style";
import SingleMiniCard from "./SingleMiniCard";
import { useDispatch, useSelector } from "react-redux";
import {
  getTicketsList,
  selectTicketsList,
} from "../../../../../../redux/features/tickets/ticketsSlice";
import { selectProjectsList } from "../../../../../../redux/features/projects/projectsSlice";
import { selectUsersList } from "../../../../../../redux/features/usersManagement/usersManagementSlice";
import { useAuth } from "../../../../../../utils/hooks/useAuth";
import { useGetTicketsByAdminIdQuery } from "../../../../../../redux/features/tickets/ticketsApi";
import { FormattedMessage } from "react-intl";

const MiniCards = ({ statusProjects }) => {
  // INIT

  //STATE
  const [cardData, setCardData] = useState([]);
  //REDUX

  const ticketCounters = useSelector(selectTicketsList).counters;
  const projectCounters = useSelector(selectProjectsList).counters;
  const userCounters = useSelector(selectUsersList).counters;

  //EFFECTS

  useEffect(() => {
    const data = [
      {
        title: <FormattedMessage id="dashboard.totalUsers" />,
        value: userCounters?.total_users,
        icon: <People />,
      },
      {
        title: <FormattedMessage id="dashboard.totalNewProjects" />,
        value: statusProjects?.projects_count,
        icon: <PendingActions />,
      },
      {
        title: <FormattedMessage id="dashboard.totalOpenTickets" />,
        value: ticketCounters.total_open_tickets,
        icon: <SpeakerNotesRounded />,
      },
    ];

    setCardData(data);
  }, [ticketCounters, projectCounters, userCounters]);
  return (
    <CardsContainer>
      {cardData?.map((data, index) => (
        <SingleMiniCard
          key={index}
          title={data.title}
          value={data.value}
          icon={data.icon}
        />
      ))}
    </CardsContainer>
  );
};

export default MiniCards;
